import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Dialog } from 'primereact/dialog'
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from 'primereact/dropdown';
import BusinessCustomersActions from "../../../Redux/transition/customers/business-customer.reducer";
import { Button } from 'primereact/button';
import CustomToast from '../../../Components/CustomToast';
import "../../../Styles/components/segment.scss";
import { normalizeSegmentsList } from "./segmentUtils";

const SubscriberToSegment = ({ visible, onHide, header, saveLabel, selectedSubscribers, rowSubClicked, customersCall, businessId,
    setSelectedSubscribers, removeLabelClicked, pageOptions, query, customerSearchCall, csvFileData, fetchAllImportedCustomers }) => {
    const { t } = useTranslation("common");
    const dispatch = useDispatch();

    const [toastTrigger, setToastTrigger] = useState(false);
    const [saveSingleClicked, setSaveSingleClicked] = useState(false);
    const [saveBulkClicked, setSaveBulkClicked] = useState(false);
    const [deleteSingleClicked, setDeleteSingleClicked] = useState(false);
    const [deleteBulkClicked, setDeleteBulkClicked] = useState(false);
    const [toastData, setToastData] = useState({
        summary: '', severity: '', detail: '', life: 0
    });
    const [selectedSegment, setSelectedSegment] = useState(null);

    //redux states
    const { segmentSuccess, addSingleSubToSegmentSuccess, addBulkSubToSegmentSuccess, removeSubToSegmentSuccess,
        addSingleSubToSegmentError, addBulkSubToSegmentError, removeSubToSegmentError, removeBulkSubToSegmentError,
        addingSingleSubToSegment, addingBulkSubToSegment, removingSubToSegment, removingBulkSubToSegment,
        removeBulkSubToSegmentSuccess, bulkListToSegmentError, bulkListToSegment, addingBulkListToSegment }
        = useSelector((state) => state.businessCustomers)

    //redux calls
    const addSingleSubscriberToSegment = useCallback((segmentId, bcId) => dispatch(BusinessCustomersActions.addingSingleSubToSegmentRequest(segmentId, bcId)), [dispatch]);
    const addBulkSubscribersToSegment = useCallback((segmentId, bcIds) => dispatch(BusinessCustomersActions.addingBulkSubToSegmentRequest(segmentId, bcIds)), [dispatch]);
    const removeSubscriberToSegment = useCallback((bcId) => dispatch(BusinessCustomersActions.removingSubToSegmentRequest(bcId)), [dispatch]);
    const removeBulkSubscriberToSegment = useCallback((bcIds) => dispatch(BusinessCustomersActions.removingBulkSubToSegmentRequest(bcIds)), [dispatch]);
    const addListToSegment = useCallback((id, segmentId) => dispatch(BusinessCustomersActions.addingBulkListToSegmentRequest(id, segmentId)), [dispatch]);

    const showToast = (summary, severity, detail) => {
        setToastData({ summary, severity, detail, life: 3000 });
        setToastTrigger(true)
    }

    useEffect(() => {
        if (!addingSingleSubToSegment && addSingleSubToSegmentSuccess && saveSingleClicked) {
            showToast(t("success"), "success", t("segment.subscriber_add"))
        }
        if (!addingBulkSubToSegment && addBulkSubToSegmentSuccess && saveBulkClicked) {
            showToast(t("success"), "success", t("segment.subscribers_add"))
        }
        if (!removingSubToSegment && removeSubToSegmentSuccess && deleteSingleClicked) {
            showToast(t("success"), "success", t("segment.subscriber_remove_success"))
        }
        if (!addingBulkListToSegment && bulkListToSegment && saveSingleClicked) {
            showToast(t("success"), "success", t("segment.subscribers_add"))
        }
        if (!removingBulkSubToSegment && removeBulkSubToSegmentSuccess && deleteBulkClicked) {
            showToast(t("success"), "success", t("segment.subscriber_bulk_remove_success"))
        }
        if (!addingSingleSubToSegment && addSingleSubToSegmentError && saveSingleClicked) {
            showToast(t("err"), "error", t("segment.subscriber_add_fail"))
        }
        if (!addingBulkListToSegment && bulkListToSegmentError && saveSingleClicked) {
            showToast(t("err"), "error", t("segment.subscriber_add_fail"))
        }
        if (!addingBulkSubToSegment && addBulkSubToSegmentError && saveBulkClicked) {
            showToast(t("err"), "error", t("segment.subscriber_add_fail"))
        }
        if (!removingSubToSegment && removeSubToSegmentError && deleteSingleClicked) {
            showToast(t("err"), "error", t("segment.subscriber_remove_fail"))
        }
        if (!removingBulkSubToSegment && removeBulkSubToSegmentError && deleteBulkClicked) {
            showToast(t("err"), "error", t("segment.subscriber_remove_fail"))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addingSingleSubToSegment, addSingleSubToSegmentSuccess, removeBulkSubToSegmentError, removeBulkSubToSegmentSuccess,
        removingBulkSubToSegment, addingBulkSubToSegment, addingBulkListToSegment, bulkListToSegment, bulkListToSegmentError,
        removeSubToSegmentSuccess, removeSubToSegmentError, removingSubToSegment, deleteBulkClicked, addBulkSubToSegmentSuccess,
        addSingleSubToSegmentError, addBulkSubToSegmentError, saveBulkClicked, saveSingleClicked, deleteSingleClicked])

    const segmentOptions = useMemo(() => {
        let availableSegments = normalizeSegmentsList(segmentSuccess);
        if (!availableSegments.length) return [];

        if (rowSubClicked && rowSubClicked.businessCustomer?.segment) {
            availableSegments = availableSegments.filter(
                (seg) => seg.id !== rowSubClicked?.businessCustomer?.segment.id
            );
        }

        return availableSegments
            .filter(item => item.name && item.id)
            .map(item => ({
                label: item.name,
                value: item.id
            }));

    }, [segmentSuccess, rowSubClicked]);

    const handleOnchange = function (e) {
        let value = e?.value;
        setSelectedSegment(value)
    }


    const handleAdd = () => {
        const segmentId = selectedSegment;
        if (!segmentId && !selectedSubscribers && !rowSubClicked && !csvFileData) {
            return;
        }
        if (rowSubClicked) {
            setSaveSingleClicked(true)
            const singleSubscriberId = rowSubClicked?.businessCustomer.id;
            addSingleSubscriberToSegment(segmentId, singleSubscriberId);
        } else if (selectedSubscribers) {
            setSaveBulkClicked(true)
            const bcIds = selectedSubscribers.map(sub =>
                typeof sub === "object" ? sub.id : sub
            );
            addBulkSubscribersToSegment(segmentId, bcIds);
        } else {
            setSaveSingleClicked(true)
            const listId = csvFileData?.id;
            addListToSegment(listId, segmentId);
        }
    };

    const handleRemove = () => {
        if (rowSubClicked) {
            setDeleteSingleClicked(true)
            const singleSubscriberId = rowSubClicked?.businessCustomer.id;
            removeSubscriberToSegment(singleSubscriberId);
        } else {
            setDeleteBulkClicked(true);
            const bcIds = selectedSubscribers.map(sub =>
                typeof sub === "object" ? sub.id : sub
            );
            removeBulkSubscriberToSegment(bcIds)
        }
    }

    const baseStyle = { fontWeight: "bold", fontSize: "14px" };
    const getStyle = (color) => ({ ...baseStyle, color });
    const segmentName = ((selectedSubscribers && selectedSubscribers[0]?.businessCustomer?.segment?.name) || rowSubClicked?.businessCustomer?.segment?.name || csvFileData?.importName) ?? t("segment.none");


    return (
        <div className='add_sub_segment'>
            <CustomToast
                {...toastData}
                trigger={toastTrigger}
                handleActionsAfterToast={() => {
                    onHide();
                    setToastTrigger(false);
                    setSaveBulkClicked(false);
                    setSaveSingleClicked(false);
                    setDeleteSingleClicked(false)
                    setDeleteBulkClicked(false)
                    if(selectedSubscribers){
                        setSelectedSubscribers([]);
                    }
                    if(selectedSubscribers || rowSubClicked){
                        customersCall(businessId, pageOptions);
                    }
                    setSelectedSegment(null);
                    if (csvFileData) {
                        fetchAllImportedCustomers(0);
                    }
                    if (query) {
                        customerSearchCall()
                    }
                }}
            />
            <Dialog
                visible={visible}
                onHide={onHide}
                header={header}
                style={{ width: "350px" }}
            >
                <div className='px-3 flex justify-content-start align-items-center'>
                    <section className='flex flex-column w-full py-2'>
                        {removeLabelClicked && rowSubClicked && rowSubClicked.businessCustomer?.segment ? <p>
                            <Trans
                                i18nKey={rowSubClicked.businessCustomer?.segment === null ? "segment.remove-hint-none" : "segment.remove-hint"}
                                values={{ customer: rowSubClicked.businessCustomer?.name, segmentName }}
                                components={{ 1: <span style={getStyle("#000000")} />, 2: <span style={getStyle("#006644")} /> }}
                            >
                            </Trans>
                            <hr style={{ borderTop: "2px solid #e0e0e0" }} className='mt-2 mb-2' />
                        </p>
                            : removeLabelClicked && selectedSubscribers?.length > 1 ? <p>
                                <Trans
                                    i18nKey={"segment.multiple_remove_hint"}
                                    components={{ 1: <span style={getStyle("#000000")} />, 2: <span style={getStyle("#D0021B")} />, 3: <span style={getStyle("#006644")} /> }}
                                >
                                </Trans>
                            </p>
                                : rowSubClicked && rowSubClicked.businessCustomer?.segment ?
                                    <div>
                                        <Trans
                                            i18nKey="segment.add-hint"
                                            values={{ customer: rowSubClicked.businessCustomer?.name, segmentName }}
                                            components={{ 1: <span style={getStyle("#000000")} />, 2: <span style={getStyle("#008DD5")} /> }}
                                        >
                                        </Trans>
                                        <hr style={{ borderTop: "2px solid #e0e0e0" }} className='my-3' />
                                        <p className='my-3' style={getStyle("#D0021B")}>{t("segment.switch_seg_")}</p>
                                    </div>
                                    : csvFileData && csvFileData.importName ?
                                        <div>
                                            <p>
                                                <Trans
                                                    i18nKey="segment.add_list_hint"
                                                    values={{ listName: csvFileData.importName }}
                                                    components={{ 1: <span style={getStyle("#000000")} /> }}
                                                >
                                                </Trans>
                                                <hr style={{ borderTop: "2px solid #e0e0e0" }} className='mt-2 mb-2' />
                                                <Trans
                                                    i18nKey="segment.multiple_add_hint"
                                                    components={{ 1: <span style={getStyle("#D0021B")} />, 2: <span style={getStyle("#000000")} />, 3: <span style={getStyle("#D0021B")} />, }}
                                                >
                                                </Trans>
                                                <hr style={{ borderTop: "2px solid #e0e0e0" }} className='mt-2 mb-2' />
                                            </p>
                                        </div>
                                        : !removeLabelClicked && selectedSubscribers?.length > 1 ?
                                            <p>
                                                <Trans
                                                    i18nKey="segment.multiple_add_hint"
                                                    components={{ 1: <span style={getStyle("#D0021B")} />, 2: <span style={getStyle("#000000")} />, 3: <span style={getStyle("#D0021B")} />, }}
                                                >
                                                </Trans>
                                                <hr style={{ borderTop: "2px solid #e0e0e0" }} className='mt-2 mb-2' />
                                            </p> : null
                        }
                        {!(removeLabelClicked && (selectedSubscribers?.length > 1 || rowSubClicked)) &&
                            <> <label className='labels'>{t("segment.segment_label")}
                                <span className='reveknew_red text-xs'>{t("red_astericks")}</span></label>
                                <Dropdown
                                    placeholder={t("segment.select_segment")}
                                    className='text-left items-center col-12 segment_drop'
                                    options={segmentOptions}
                                    optionLabel='label'
                                    value={selectedSegment}
                                    onChange={(e) => handleOnchange(e)}
                                    id='segment_dialog'
                                >
                                </Dropdown></>}

                        <div className='add_sub_buttons mt-4'>
                            <Button id='clear_segment_btn' onClick={onHide}><i className='pi pi-times mr-1' />{t("cancel")}</Button>
                            <Button id='send_invite_btn' className='m-0'
                                onClick={() => { removeLabelClicked ? handleRemove() : handleAdd() }}
                                loading={addingSingleSubToSegment || addingBulkSubToSegment || removingSubToSegment || removingBulkSubToSegment || addingBulkListToSegment}
                                disabled={!selectedSegment || saveSingleClicked || saveBulkClicked || deleteSingleClicked || deleteBulkClicked}
                            >{saveLabel}</Button>
                        </div>
                    </section>
                </div>
            </Dialog>
        </div>
    )
}

export default SubscriberToSegment